import * as Device from 'expo-device';
import { Platform } from 'react-native';

const BROWSERS: { name: string; pattern: RegExp }[] = [
  { name: 'Edge', pattern: /Edg(?:e|A|iOS)?\/(\d+(?:\.\d+)?)/ },
  { name: 'Opera', pattern: /OPR\/(\d+(?:\.\d+)?)/ },
  { name: 'Samsung Internet', pattern: /SamsungBrowser\/(\d+(?:\.\d+)?)/ },
  { name: 'Chrome', pattern: /CriOS\/(\d+(?:\.\d+)?)/ },
  { name: 'Firefox', pattern: /FxiOS\/(\d+(?:\.\d+)?)/ },
  { name: 'Firefox', pattern: /Firefox\/(\d+(?:\.\d+)?)/ },
  { name: 'Chrome', pattern: /Chrome\/(\d+(?:\.\d+)?)/ },
  { name: 'Safari', pattern: /Version\/(\d+(?:\.\d+)?).*Safari\// },
];

function getBrowser(): string | null {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const match = BROWSERS.map(({ name, pattern }) => ({ name, version: pattern.exec(userAgent)?.[1] })).find(
    (browser) => browser.version
  );
  if (!match) return null;

  const installed =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;

  return `${match.name} ${match.version}${installed ? ' (PWA)' : ''}`;
}

/**
 * Short device summary for support tickets, e.g. "Apple iPhone 14 Pro, iOS 18.1" on native or
 * "Apple iPhone, iOS 18.1, Safari 18.1 (PWA)" on web
 */
export function getDeviceDescription(): string {
  const model = [Device.manufacturer, Device.modelName].filter(Boolean).join(' ');
  // On Android, osName is Build.VERSION.BASE_OS, which some OEMs (e.g. Samsung) fill with the build fingerprint
  const osName = Platform.OS === 'android' ? 'Android' : Device.osName;
  const os = [osName, Device.osVersion].filter(Boolean).join(' ');
  const browser = Platform.OS === 'web' ? getBrowser() : null;

  return [model, os, browser].filter(Boolean).join(', ');
}
